/**
 * DeliverySacPublicRequest
 * @author ftgibran
 */
import {
  Model,
  ResponseFill,
  HttpIgnore,
  ID, HttpBody, $,
} from 'simpli-web-sdk'
import RastreamentoDistanciaResponse from '@/model/response/RastreamentoDistanciaResponse'

@HttpIgnore()
export default class DeliverySacPublicRequest extends Model {
  readonly $name: string = 'DeliverySacRequest'

  @ResponseFill('h')
  hash: string | null = null

  @ResponseFill('token')
  token: string | null = null

  @ResponseFill('danfe')
  danfe: string | null = null

  @ResponseFill('nroFiscal')
  nroFiscal: string | null = null

  @ResponseFill('nroCorreios')
  nroCorreios: string | null = null

  @ResponseFill('nroPedido')
  nroPedido: string | null = null

  @ResponseFill('cte')
  cte: string | null = null

  @ResponseFill('cpfCnpj')
  cpfCnpj: string | null = null

  @ResponseFill('idEmbarcador')
  idEmbarcador: ID | null = null

  @ResponseFill('dataInclusao')
  dataCriacao: string | null = null

  @ResponseFill('login')
  login: string | null = null

  @ResponseFill('senha')
  senha: string | null = null

  @ResponseFill('idCarga')
  idCarga: ID | null = null

  get isCleared() {
    return !this.danfe
      && !this.nroFiscal
      && !this.nroCorreios
      && !this.nroPedido
      && !this.cte
      && !this.cpfCnpj
      && !this.idEmbarcador
      && !this.idCarga
      && !this.hash
  }

  clean() {
    this.danfe = null
    this.nroFiscal = null
    this.nroCorreios = null
    this.nroPedido = null
    this.cte = null
    this.cpfCnpj = null
    this.idEmbarcador = null
    this.dataCriacao = null
    this.login = null
    this.senha = null
    this.idCarga = null
  }

  async getRastreamentoDistancia(id: ID, spinner = 'getRastreamentoDistancia') {
    const fetch = async () => {
      return await new HttpBody<RastreamentoDistanciaResponse>(RastreamentoDistanciaResponse)
        .GET(`/user/carga/sac/rastreamento-distancia?idCarga=${id}`)
    }

    return await $.await.run(fetch, spinner, 1000)
  }
}
